import React,{useEffect,useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import ConversionLogsTab from '../components/ConversionLogsTab';
import PostbackConfigPanel from '../components/PostbackConfigPanel';
import RawLogsTab from '../components/RawLogsTab';
import supabase from '../supabase/supabase';

const {FiSettings,FiList,FiDatabase,FiLock,FiRefreshCw,FiCode} = FiIcons;
const TAB_STORAGE_KEY = 'admin_active_tab';

export default function AdminDashboard() {
  const [isAuthenticated,setIsAuthenticated] = useState(
    sessionStorage.getItem('admin_unlocked') === 'true'
  );
  const [password,setPassword] = useState('');
  const [activeTab,setActiveTab] = useState(
    () => sessionStorage.getItem(TAB_STORAGE_KEY) || 'config'
  );
  const [templateUrl,setTemplateUrl] = useState('');
  const [isSaving,setIsSaving] = useState(false);
  const [logs,setLogs] = useState([]);
  const [slots,setSlots] = useState([]);

  const tabs = [
    {id: 'config',label: 'Postback Config',icon: FiSettings},
    {id: 'logs',label: 'Conversion Logs',icon: FiList},
    {id: 'raw-logs',label: 'Raw Logs',icon: FiCode},
    {id: 'slots',label: 'Slot Leases Pool',icon: FiDatabase}
  ];

  useEffect(() => {
    if (isAuthenticated) {
      fetchConfig();
      fetchLogs();
      fetchSlots();
    }
  },[isAuthenticated]);

  const selectTab = (tabId) => {
    sessionStorage.setItem(TAB_STORAGE_KEY,tabId);
    setActiveTab(tabId);
  };

  const handleLogin = (event) => {
    event.preventDefault();
    if (password === 'nofear') {
      sessionStorage.setItem('admin_unlocked','true');
      setIsAuthenticated(true);
      return;
    }
    alert('Incorrect password');
  };

  const fetchConfig = async () => {
    const {data} = await supabase
      .from('app_settings')
      .select('value')
      .eq('key','postback_url_template')
      .single();
    if (data?.value) {
      const value = typeof data.value === 'string' && data.value.startsWith('"')
        ? JSON.parse(data.value) : data.value;
      setTemplateUrl(value);
    }
  };

  const saveConfig = async (url) => {
    setIsSaving(true);
    const {error} = await supabase
      .from('app_settings')
      .upsert({key: 'postback_url_template',value: JSON.stringify(url)});
    if (error) {alert(`Failed to save template: ${error.message}`);} 
    else {setTemplateUrl(url);alert('Template saved successfully!');}
    setIsSaving(false);
  };

  const fetchLogs = async () => {
    const {data} = await supabase
      .from('conversion_logs')
      .select('*')
      .order('created_at',{ascending: false})
      .limit(50);
    setLogs(data || []);
  };

  const fetchSlots = async () => {
    const {data} = await supabase
      .from('dynamic_slots_1730000000000')
      .select('*')
      .order('slot_number',{ascending: true});
    setSlots(data || []);
  };

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="bg-white p-8 rounded-xl shadow-lg border border-slate-200 max-w-sm w-full">
          <div className="flex justify-center mb-6">
            <div className="bg-teal-100 p-4 rounded-full text-teal-600">
              <SafeIcon icon={FiLock} className="text-2xl" />
            </div>
          </div>
          <h1 className="text-2xl font-bold text-center mb-6 text-slate-800">Admin Access</h1>
          <form onSubmit={handleLogin}>
            <input type="password"
              className="w-full px-4 py-3 border border-slate-300 rounded-lg mb-4 focus:ring-2 focus:ring-teal-500 outline-none transition"
              placeholder="Enter password..."
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
            <button type="submit"
              className="w-full bg-teal-600 text-white py-3 rounded-lg hover:bg-teal-700 transition font-semibold">
              Unlock Dashboard
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 p-6 pt-12">
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-end items-center mb-8">
          <button onClick={() => {sessionStorage.removeItem('admin_unlocked');setIsAuthenticated(false);}}
            className="text-slate-500 hover:text-slate-700 text-sm font-medium border border-slate-300 px-4 py-2 rounded-lg hover:bg-slate-100 transition">
            Lock Session
          </button>
        </div>
        <div className="flex gap-2 mb-6 border-b border-slate-200 overflow-x-auto">
          {tabs.map((tab) => (
            <button key={tab.id} onClick={() => selectTab(tab.id)}
              className={`flex items-center gap-2 px-5 py-4 font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === tab.id ? 'border-teal-600 text-teal-700 bg-teal-50/50' : 'border-transparent text-slate-500 hover:text-slate-700 hover:bg-slate-100'}`}>
              <SafeIcon icon={tab.icon} />
              {tab.label}
            </button>
          ))}
        </div>
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-8 min-h-[500px]">
          {activeTab === 'config' && (
            <PostbackConfigPanel templateUrl={templateUrl} setTemplateUrl={setTemplateUrl} isSaving={isSaving} onSave={saveConfig} />
          )}
          {activeTab === 'logs' && <ConversionLogsTab logs={logs} onRefresh={fetchLogs} />}
          {activeTab === 'raw-logs' && <RawLogsTab />}
          {activeTab === 'slots' && (
            <div>
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold text-slate-800">Slot Leases Pool (250)</h2>
                <button onClick={fetchSlots}
                  className="text-teal-600 hover:text-teal-700 bg-teal-50 px-4 py-2 rounded-lg font-medium flex items-center gap-2 text-sm transition">
                  <SafeIcon icon={FiRefreshCw} /> Refresh Table
                </button>
              </div>
              <div className="overflow-x-auto border border-slate-200 rounded-lg">
                <table className="w-full text-sm text-left border-collapse">
                  <thead className="bg-slate-100 text-slate-700 border-b border-slate-200 uppercase text-xs font-bold tracking-wider">
                    <tr>
                      <th className="p-4">Slot #</th>
                      <th className="p-4">Status</th>
                      <th className="p-4">Active Tx ID</th>
                      <th className="p-4">Expires At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {slots.length === 0 ? (
                      <tr><td colSpan="4" className="p-8 text-center text-slate-500">No slots allocated yet.</td></tr>
                    ) : slots.map((slot) => {
                      const isExpired = new Date(slot.expires_at) < new Date();
                      return (
                        <tr key={slot.slot_number} className="border-b border-slate-100 hover:bg-slate-50 transition">
                          <td className="p-4 font-bold text-slate-700">#{slot.slot_number}</td>
                          <td className="p-4">
                            <span className={`px-2.5 py-1 rounded-full text-xs font-bold ${isExpired ? 'bg-slate-100 text-slate-600 border border-slate-200' : 'bg-teal-100 text-teal-700 border border-teal-200'}`}>
                              {isExpired ? 'Available / Expired' : 'Active'}
                            </span>
                          </td>
                          <td className="p-4 font-mono text-xs text-slate-600">{slot.transaction_id || '-'}</td>
                          <td className="p-4 text-slate-500">{slot.expires_at ? new Date(slot.expires_at).toLocaleString() : '-'}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}